import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "../api";
import { AuthLayout, btnCls } from "./Login";
import { PageLoader } from "../ui";

export default function ParentConsent() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [result, setResult] = useState("");
  useEffect(() => { api(`/auth/parent/${token}`).then(setInfo).catch((e) => setErr(e.message)); }, [token]);
  const decide = async (accept) => {
    try { setResult((await api(`/auth/parent/${token}`, { method: "POST", body: { accept } })).status); } catch (e) { setErr(e.message); }
  };
  if (err) return <AuthLayout overline="Einwilligung" title="Link ungültig"><p className="text-[#A1A1AA]" data-testid="parent-error">{err}</p></AuthLayout>;
  if (result) return (
    <AuthLayout overline="Einwilligung" title={result === "active" ? "Danke!" : "Konto gelöscht"}>
      <p className="text-[#A1A1AA]" data-testid="parent-result">{result === "active" ? "Das Konto ist jetzt freigeschaltet. Dein Kind kann sich ab sofort anmelden." : "Das Konto und alle Angaben wurden gelöscht."}</p>
      {result === "active" && <Link to="/training/login" className="text-[#c1ff72] underline mt-4 inline-block">Zur Anmeldung</Link>}
    </AuthLayout>
  );
  if (!info) return <PageLoader />;
  if (info.status !== "pending_parent") return <AuthLayout overline="Einwilligung" title="Bereits bestätigt"><p className="text-[#A1A1AA]" data-testid="parent-already">Dieses Konto ist bereits freigeschaltet.</p></AuthLayout>;
  return (
    <AuthLayout overline="Einwilligung der Eltern" title={`Konto für ${info.first_name} ${info.last_name}`}>
      <div className="space-y-6" data-testid="parent-consent">
        <p className="text-[#A1A1AA] text-sm">Geburtsjahr {info.birth_year}. Für Kinder unter 16 Jahren brauchen wir deine Einwilligung (Art. 8 DSGVO). Folgende Daten werden gespeichert:</p>
        <ul className="space-y-2">{info.data.map((d) => <li key={d} className="flex gap-2 text-sm text-white"><Check className="w-4 h-4 text-[#c1ff72] mt-0.5" />{d}</li>)}</ul>
        <p className="text-xs text-[#71717A]">In Bestenlisten erscheint höchstens der Vorname mit Initial. Kontaktdaten werden nie veröffentlicht. Du kannst die Einwilligung jederzeit widerrufen und das Konto löschen lassen.</p>
        <button onClick={() => decide(true)} className={btnCls} data-testid="parent-accept">Ich willige ein</button>
        <button onClick={() => decide(false)} className="w-full h-12 border border-white/15 text-white" data-testid="parent-decline">Ablehnen und Konto löschen</button>
      </div>
    </AuthLayout>
  );
}
